import dynamic from "next/dynamic";

export const BlogPostContent = dynamic(() => import("./component"));
